import React, { Component } from "react";
import { Switch as AntSwitch } from "antd";
import FormItem from "./FormItem";

class Switch extends Component {
  render() {
    const { getFieldDecorator } = this.props.form;
    const { value, fieldSettings } = this.props;

    if (this.props.value) {
      fieldSettings.valuePropName = "checked";
    }

    return (
      <FormItem {...this.props}>
        {getFieldDecorator(this.props.attribute, fieldSettings)(
          <AntSwitch
            size="large"
            disabled={this.props.disabled}
            onChange={this.props.handleChange}
          />
        )}
      </FormItem>
    );
  }
}

export default Switch;



// WEBPACK FOOTER //
// ./src/inputs/Switch.js